import { createAction } from 'redux-actions';
import { studentDetailActionTypes as act } from './actionTypes';

export default function studentDetail(
  state = {
    student: null,
    studentIdEnable: { agreementId: '', enableFlag: true, fund: null },
  },
  { payload, type }
) {
  switch (type) {
    case act.SET_STUDENT_DETAIL: {
      const { student } = payload;

      return {
        ...state,
        student: student,
      };
    }
    case act.SET_STUDENT_ID_ENABLE: {
      return {
        ...state,
        studentIdEnable: payload.student,
      };
    }
    case act.UPDATE_STUDENT_ID_ENABLE: {
      const previousStudent = { ...state.studentIdEnable };
      previousStudent.enableFlag =
        previousStudent.agreementId === payload.student.agreementID
          ? false
          : previousStudent.enableFlag;
      previousStudent.agreementId =
        previousStudent.agreementId === payload.student.agreementID
          ? ''
          : previousStudent.agreementId;
      return {
        ...state,
        studentIdEnable: { ...previousStudent },
      };
    }
    case act.CLEAR_STUDENT_ID: {
      if (
        state?.studentIdEnable?.fund?.formattedEntityNames !==
        payload?.fund?.formattedEntityNames
      ) {
        return {
          ...state,
          student: null,
          studentIdEnable: { agreementId: '', enableFlag: true, fund: null },
        };
      }
      return {
        ...state,
      };
    }
    default:
      return state;
  }
}

export function updateStudentDetail(student) {
  return createAction(act.SET_STUDENT_DETAIL)({ student });
}
